<script>
import { createBiomarker } from '../services/biomarkerService'
import BiomarkerForm from '../components/biomarker/BiomarkerForm'
import { ContentLoader } from 'vue-content-loader'
import { isMobile } from 'mobile-device-detect'
import { getDefaultBiomarker } from '../utils/biomarker'

export default {
  name: 'BiomarkerAddView',
  components: { ContentLoader, BiomarkerForm },
  data() {
    return {
      biomarker: getDefaultBiomarker(),
      loading: false,
      isMobile: isMobile
    }
  },
  methods: {
    async addBiomarker(biomarker) {
      this.loading = true
      try {
        await createBiomarker(biomarker)
        this.$router.replace({ name: 'BiomarkerListAdminView' })
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  }
}
</script>

<template>
  <div class="container section">
    <ContentLoader
      v-if="loading"
      :height="150"
      :width="isMobile ? 200 : 400"
      :speed="3"
    >
      <rect x="0" y="0" rx="3" ry="3" width="155" height="12" />
      <rect x="0" y="20" rx="3" ry="3" width="350" height="4" />
      <rect x="0" y="30" rx="3" ry="3" width="380" height="4" />
      <rect x="0" y="40" rx="3" ry="3" width="201" height="4" />
    </ContentLoader>
    <div v-if="!loading" class="container">
      <div class="column">
        <h1 class="title">
          Biomarker
        </h1>
      </div>
      <BiomarkerForm :biomarker="biomarker" @submit="addBiomarker" />
    </div>
  </div>
</template>
